"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsTabletOrMobile = exports.isTabletOrMobile = exports.useWindowWidth = void 0;
const React = __importStar(require("react"));
function useWindowWidth() {
    const [width, setWidth] = React.useState(window.innerWidth);
    React.useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return width;
}
exports.useWindowWidth = useWindowWidth;
// Same as spacing definition for tabletxl
const isTabletOrMobile = () => window.matchMedia('only screen and (max-width: 1030px)').matches;
exports.isTabletOrMobile = isTabletOrMobile;
function useIsTabletOrMobile() {
    const [tabletOrMobile, setTabletOrMobile] = React.useState(exports.isTabletOrMobile());
    React.useEffect(() => {
        const handleResize = () => setTabletOrMobile(exports.isTabletOrMobile());
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return tabletOrMobile;
}
exports.useIsTabletOrMobile = useIsTabletOrMobile;
//# sourceMappingURL=windowWidth.js.map